import React from 'react';

function CheckboxTickIcon({ ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
      {...props}
    >
      <path
        fill="#fff"
        d="M10.816 19.5c-.477 0-.876-.187-1.2-.562L5.37 13.94a1.476 1.476 0 01-.288-.443A1.247 1.247 0 015 13.046c0-.343.12-.628.361-.855.241-.227.545-.34.912-.34.411 0 .753.163 1.027.49l3.483 4.205L17.61 6.133c.158-.227.323-.388.492-.483.17-.1.381-.15.633-.15.361 0 .663.114.904.34a1.1 1.1 0 01.361.848c0 .132-.025.269-.074.412-.044.137-.118.28-.222.427L12.04 18.89c-.285.407-.693.61-1.224.61z"
      ></path>
    </svg>
  );
}

export default CheckboxTickIcon;
